import React from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input} from 'reactstrap';
import apiBarcode from '../../services/api/apiBarcode';
import {pushNewItemHistory} from "../../services/api/apiItemHistory";

class ModalEditProduct extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            product: {},
            isLoadingSave: false
        };
    }

    componentDidMount() {
        this._loadStateFromProps();
    }

    _loadStateFromProps = () => {
        const {product} = this.props;
        this.setState({product});
    };

    _handleChangeInput = (e) => {
        const {name, value} = e.target;
        const {product} = this.state;
        this.setState({product: {...product, [name]: value}});
    };

    _renderIconLoading = () => {
        if (this.state.isLoadingSave)
            return <i className='icon-spinner2 spinner ml-2'/>;
    };

    _handleClickSave = async () => {
        this.setState({isLoadingSave: true});

        try {
            const {product: productOld} = this.props
            const {barcodeId: barcodeIdOld, productId: productIdOld, barcodeNumber, pos, ...productWithoutIdOld} = productOld
            const {product} = this.state;
            const {barcodeId, productId, barcodeNumber: barcodeNumberNew, pos: posNew, ...productWithoutId} = product;

            const diff = this._diff(productWithoutIdOld, productWithoutId)
            let from = []
            let to = []
            diff.forEach(itemDiff => {
                from.push(`${itemDiff}: ${productWithoutIdOld[itemDiff]}`)
                to.push(`${itemDiff}: ${productWithoutId[itemDiff]}`)
            })

            const resUpdated = await apiBarcode.updateBarcodeProduct(barcodeId, productId, productWithoutId);
            const {success, message} = resUpdated.data;
            if (!success) throw new Error(message);

            await this.props.reload();
            this.props.toggle();

            return pushNewItemHistory(`${barcodeNumber}_${pos}`, {
                event_key: 'edit_order_item',
                event_description: `Edit item order`,
                event_meta: {
                    from: from.toString(', '),
                    to: to.toString(', '),
                }
            })
        } catch (e) {
            alert(e.message);
        }

        this.setState({isLoadingSave: false});
    }

    _diff = (oldObj, newObj) => {
        return Object.entries(newObj).map(([key, value]) => {
            if (oldObj[key] !== newObj[key]) {
                return key
            }
            return null
        }).filter(Boolean)
    }

    render() {
        const {isOpen, toggle} = this.props;
        const {isLoadingSave, product} = this.state;
        const {mockUpFront, mockUpBack, designFront, designBack, size, color, type} = product;

        return (
            <div>
                <Modal isOpen={isOpen} toggle={toggle} className={this.props.className}>
                    <ModalHeader toggle={toggle}>Edit Item</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>Mock Up Front</Label>
                            <Input name='mockUpFront' value={mockUpFront} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Mock Up Back</Label>
                            <Input name='mockUpBack' value={mockUpBack} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Design Front</Label>
                            <Input name='designFront' value={designFront} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Design Back</Label>
                            <Input name='designBack' value={designBack} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Size</Label>
                            <Input name='size' value={size} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Color</Label>
                            <Input name='color' value={color} onChange={this._handleChangeInput}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Type</Label>
                            <Input name='type' value={type} onChange={this._handleChangeInput}/>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggle}>Cancel</Button>{' '}
                        <Button color="primary" onClick={this._handleClickSave} disabled={isLoadingSave}>
                            Save
                            {this._renderIconLoading()}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ModalEditProduct;